<template>
    <div class="dict-page">
        <!-- 查询筛选卡片 -->
        <el-card shadow="always" class="filter-card">
            <div slot="header" class="card-header">
                <div class="card-header-left">
                    <i class="el-icon-collection"></i>
                    <span>字典管理</span>
                    <el-divider direction="vertical"></el-divider>
                    <span class="header-sub">筛选条件</span>
                </div>
            </div>
            <el-form :inline="true" :model="query" class="filter-form">
                <el-form-item label="字典名称">
                    <el-input clearable v-model="query.dictName" placeholder="请输入字典名称" style="width: 160px"></el-input>
                </el-form-item>
                <el-form-item label="字典类型">
                    <el-input clearable v-model="query.dictType" placeholder="请输入字典类型" style="width: 160px"></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="query.status" placeholder="全部状态" clearable style="width: 120px">
                        <el-option label="正常" :value="true"></el-option>
                        <el-option label="停用" :value="false"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
                    <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
                </el-form-item>
            </el-form>
        </el-card>

        <!-- 表格卡片 -->
        <el-card shadow="always" class="table-card">
            <div slot="header" class="card-header">
                <div class="card-header-left">
                    <span>数据列表</span>
                    <span class="total-badge">共 <b>{{ total }}</b> 条</span>
                </div>
                <div class="card-header-right">
                    <el-button type="warning" icon="el-icon-refresh" @click="btnSyncTenantDict" :loading="syncLoading">同步租户字典</el-button>
                    <el-button type="primary" icon="el-icon-plus" @click="btnInsert(null)">新增字典</el-button>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                stripe
                v-loading="tableLoading"
                element-loading-text="加载中..."
                style="width: 100%">
                <el-table-column type="index" label="序号" width="100" align="center"/>
                <el-table-column prop="dictName" label="字典名称" show-overflow-tooltip/>
                <el-table-column prop="dictType" label="字典类型" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-link type="primary" @click="gotoDictData(scope.row.dictType)">{{ scope.row.dictType }}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.status ? 'success' : 'danger'" size="small" effect="plain">
                            {{ scope.row.status ? '正常' : '停用' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注" show-overflow-tooltip/>
                <el-table-column prop="createTime" label="创建时间" width="170" align="center"/>
                <el-table-column align="center" label="操作" width="270" fixed="right">
                    <template slot-scope="scope">
                        <div class="action-btns">
                            <el-button type="primary" size="mini" icon="el-icon-view" @click="gotoDictData(scope.row.dictType)">数据</el-button>
                            <el-button type="success" size="mini" icon="el-icon-edit" @click="btnInsert(scope.row)">编辑</el-button>
                            <el-button type="danger" size="mini" icon="el-icon-delete" @click="btnDelete(scope.row.id)">删除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrapper" v-if="total > 0">
                <el-pagination
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="query.currentPage"
                    :page-size="query.pageSize"
                    :total="total">
                </el-pagination>
            </div>
        </el-card>

        <!-- 新增/编辑对话框 -->
        <el-dialog
            :close-on-click-modal="false"
            :title="dialogTitle"
            :visible.sync="dialogVisible"
            width="520px"
            class="dict-dialog">
            <el-form :model="formData" ref="formData" :rules="rules" label-width="80px">
                <el-form-item label="字典名称" prop="dictName">
                    <el-input v-model="formData.dictName" maxlength="50" placeholder="请输入字典名称"></el-input>
                </el-form-item>
                <el-form-item label="字典类型" prop="dictType">
                    <el-input v-model="formData.dictType" maxlength="50" placeholder="请输入字典类型编码"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input type="textarea" v-model="formData.remark" maxlength="200" placeholder="请输入备注" :rows="3"></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    <el-radio-group v-model="formData.status">
                        <el-radio :label="true">正常</el-radio>
                        <el-radio :label="false">停用</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitForm" :loading="submitLoading">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { listDictTypes, saveDictType, getDictTypeById, deleteDictType } from '@/api/system/dict-type'
import { syncDictData } from '@/api/system/dict-data'

export default {
    name: 'Dict',
    data() {
        return {
            tableData: [],
            total: 0,
            tableLoading: false,
            submitLoading: false,
            syncLoading: false,
            query: {
                currentPage: 1,
                pageSize: 10,
                dictName: '',
                dictType: '',
                status: null
            },
            dialogVisible: false,
            dialogTitle: '',
            formData: {
                id: null,
                dictName: '',
                dictType: '',
                remark: '',
                status: true
            },
            rules: {
                dictName: [
                    { required: true, message: '请输入字典名称', trigger: 'blur' },
                    { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
                ],
                dictType: [
                    { required: true, message: '请输入字典类型编码', trigger: 'blur' },
                    { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
                ]
            }
        }
    },
    created() {
        this.load()
    },
    methods: {
        async load() {
            this.tableLoading = true
            try {
                const data = await listDictTypes(this.query)
                this.tableData = data.list || []
                this.total = data.total || 0
            } catch (e) {
                console.error('加载字典列表失败:', e)
            } finally {
                this.tableLoading = false
            }
        },
        handleSearch() {
            this.query.currentPage = 1
            this.load()
        },
        handleReset() {
            this.query = {
                currentPage: 1,
                pageSize: 10,
                dictName: '',
                dictType: '',
                status: null
            }
            this.load()
        },
        currentChange(num) {
            this.query.currentPage = num
            this.load()
        },
        sizeChange(size) {
            this.query.pageSize = size
            this.query.currentPage = 1
            this.load()
        },
        btnInsert(row) {
            if (row) {
                this.dialogTitle = '编辑字典'
                this.formData = {
                    id: row.id,
                    dictName: row.dictName || '',
                    dictType: row.dictType || '',
                    remark: row.remark || '',
                    status: row.status != null ? row.status : true
                }
            } else {
                this.dialogTitle = '新增字典'
                this.formData = {
                    id: null,
                    dictName: '',
                    dictType: '',
                    remark: '',
                    status: true
                }
            }
            this.$nextTick(() => {
                if (this.$refs.formData) {
                    this.$refs.formData.clearValidate()
                }
            })
            this.dialogVisible = true
        },
        async btnDelete(id) {
            try {
                await this.$confirm('确定要删除该字典吗？删除后不可恢复。', '删除确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                await deleteDictType([id])
                this.$message.success('删除成功')
                this.load()
            } catch (e) {
                if (e !== 'cancel') {
                }
            }
        },
        submitForm() {
            this.$refs.formData.validate(async valid => {
                if (!valid) return
                this.submitLoading = true
                try {
                    await saveDictType(this.formData)
                    this.$message.success(this.formData.id ? '更新成功' : '新增成功')
                    this.dialogVisible = false
                    this.load()
                } catch (e) {
                    this.$message.error(e.message || '操作失败')
                } finally {
                    this.submitLoading = false
                }
            })
        },
        gotoDictData(dictType) {
            this.$router.push('/system-content/dict-data/' + dictType)
        },
        async btnSyncTenantDict() {
            try {
                await this.$confirm('确定要将管理员租户(000000)的字典同步到所有租户吗？\n\n- 新增：目标租户不存在的字典自动新增\n- 更新：已存在的字典按管理员数据更新\n- 删除：管理员已删除的字典同步删除', '同步确认', {
                    confirmButtonText: '开始同步',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
            } catch (e) {
                return
            }
            this.syncLoading = true
            try {
                await syncDictData()
                this.$message.success('租户字典同步完成')
            } catch (e) {
                this.$message.error(e.message || '同步失败')
            } finally {
                this.syncLoading = false
            }
        }
    }
}
</script>

<style scoped lang="scss">
.dict-page {
    padding: 0;

    .filter-card {
        margin: 10px 15px;

        ::v-deep .el-card__header {
            padding: 16px 20px;
            background: #fafafa;
            border-bottom: 1px solid #ebeef5;
        }
    }

    .table-card {
        margin: 10px 15px;

        ::v-deep .el-card__header {
            padding: 14px 20px;
            background: #fafafa;
            border-bottom: 1px solid #ebeef5;
        }
    }

    .card-header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .card-header-left {
            display: flex;
            align-items: center;
            gap: 10px;
            font-size: 15px;
            font-weight: 600;
            color: #303133;

            i {
                font-size: 18px;
                color: #409eff;
            }

            .header-sub {
                font-size: 13px;
                font-weight: 500;
                color: #909399;
            }

            .total-badge {
                font-size: 13px;
                font-weight: 400;
                color: #909399;
                margin-left: 8px;

                b {
                    color: #409eff;
                    font-size: 16px;
                    font-weight: 600;
                }
            }
        }

        .card-header-right {
            display: flex;
            align-items: center;
            gap: 10px;
        }
    }

    .filter-form {
        padding: 4px 0 0;

        ::v-deep .el-form-item {
            margin-bottom: 8px;
        }
    }

    .pagination-wrapper {
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
    }

    .action-btns {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 6px;
        white-space: nowrap;

        .el-button + .el-button {
            margin-left: 0;
        }
    }

    ::v-deep .el-divider--vertical {
        height: 1.2em;
        margin: 0 4px;
    }

    ::v-deep .el-table {
        th {
            background: #fafafa;
            color: #606266;
            font-weight: 600;
            font-size: 13px;
        }

        td {
            font-size: 13px;
        }

        .el-tag--plain {
            font-weight: 500;
        }
    }

    ::v-deep .el-dialog {
        border-radius: 6px;
        overflow: hidden;

        .el-dialog__header {
            padding: 16px 24px;
            border-bottom: 1px solid #ebeef5;

            .el-dialog__title {
                font-size: 16px;
                font-weight: 600;
                color: #303133;
            }
        }

        .el-dialog__body {
            padding: 24px 30px 8px;
        }

        .el-dialog__footer {
            padding: 14px 30px;
            border-top: 1px solid #ebeef5;
        }
    }
}

@media screen and (max-width: 768px) {
    .dict-page {
        .card-header {
            flex-wrap: wrap;
            gap: 8px;
        }

        .filter-form {
            ::v-deep .el-form--inline .el-form-item {
                display: block;
                width: 100%;
                margin-bottom: 12px;
            }

            ::v-deep .el-form--inline .el-form-item .el-form-item__content {
                width: 100%;
            }

            ::v-deep .el-form--inline .el-form-item .el-form-item__content .el-select,
            ::v-deep .el-form--inline .el-form-item .el-form-item__content .el-input {
                width: 100% !important;
            }
        }

        ::v-deep .el-card__body {
            padding: 12px;
        }

        ::v-deep .el-table {
            overflow-x: auto;
            display: block;
        }

        ::v-deep .el-dialog {
            width: 95% !important;
            margin: 10px auto !important;
        }

        ::v-deep .el-dialog__body {
            padding: 16px;
        }

        ::v-deep .el-dialog__footer {
            padding: 12px 16px;
        }

        ::v-deep .el-pagination {
            white-space: normal;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            gap: 4px;
        }

        ::v-deep .el-pagination .el-pagination__total,
        ::v-deep .el-pagination .el-pagination__sizes {
            margin-right: 0;
        }

        ::v-deep .el-pagination button,
        ::v-deep .el-pagination .el-pager li {
            min-width: 28px;
            height: 28px;
            line-height: 28px;
            font-size: 12px;
        }
    }
}
</style>
